<app-tab-layout [loading]="loading()" [error]="error">
  @if (initialized()) {
    <div class="charts-container">
      <div class="chart-wrapper">
        <app-pie [disableAnimations]="true" [data]="countData" />
        <span class="chart-label">{{ dictionaryService.get('Count') }}</span>
      </div>
      <div class="chart-wrapper">
        <app-pie [disableAnimations]="true" [data]="specialitiesData" />
        <span class="chart-label">{{ dictionaryService.get('Specialities') }}</span>
      </div>
    </div>
  }
</app-tab-layout>
